import 'reflect-metadata';
import { getPackageInfo } from '#environment/index.js';
import ServiceDescriptor from '../ServiceDescriptor.js';
const Service = (newMetadata = {}) => {
    const { dir } = getPackageInfo('CALLSITES');
    return (target) => ServiceDescriptor.load(target).addServiceMetadata('core', {
        ...newMetadata,
        dir,
    });
};
Service.rest =
    (newMetadata = {}) => (target) => ServiceDescriptor.load(target).addServiceMetadata('rest', newMetadata);
Service.grpc =
    (newMetadata = {}) => (target) => ServiceDescriptor.load(target).addServiceMetadata('grpc', newMetadata);
const Method = (newMetadata) => (target, methodName) => {
    ServiceDescriptor.load(target).addCoreMethodMetadata(methodName, {
        methodName,
        request: Reflect.getMetadata('design:paramtypes', target, methodName)[1],
        response: Reflect.getMetadata('design:returntype', target, methodName),
        throws: [],
        deprecated: false,
        ...newMetadata,
    });
};
Method.rest =
    (newMetadata = {}) => (target, methodName) => ServiceDescriptor.load(target).addRestMethodMetadata(methodName, newMetadata);
Method.grpc =
    (newMetadata = {}) => (target, methodName) => ServiceDescriptor.load(target).addGrpcMethodMetadata(methodName, newMetadata);
export { Method, Service };
//# sourceMappingURL=decorators.js.map